import { render, staticRenderFns } from "./ClientConfirmModal.vue?vue&type=template&id=7910cb4a&"
import script from "./ClientConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ClientConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports